/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Order,
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
} from './Order';
import {
    ShippingProduct,
    ShippingProductFromJSON,
    ShippingProductFromJSONTyped,
    ShippingProductToJSON,
} from './ShippingProduct';

/**
 * 
 * @export
 * @interface Shipping
 */
export interface Shipping {
    /**
     * 
     * @type {Order}
     * @memberof Shipping
     */
    orderByOrderId?: Order;
    /**
     * 
     * @type {number}
     * @memberof Shipping
     */
    orderId?: number;
    /**
     * 
     * @type {Date}
     * @memberof Shipping
     */
    shippingDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof Shipping
     */
    shippingId?: number;
    /**
     * 
     * @type {Array<ShippingProduct>}
     * @memberof Shipping
     */
    shippingProductsByShippingId?: Array<ShippingProduct>;
    /**
     * 
     * @type {string}
     * @memberof Shipping
     */
    shippingStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof Shipping
     */
    trackingNumber?: string;
}

export function ShippingFromJSON(json: any): Shipping {
    return ShippingFromJSONTyped(json, false);
}

export function ShippingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Shipping {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderByOrderId': !exists(json, 'orderByOrderId') ? undefined : OrderFromJSON(json['orderByOrderId']),
        'orderId': !exists(json, 'orderId') ? undefined : json['orderId'],
        'shippingDate': !exists(json, 'shippingDate') ? undefined : (new Date(json['shippingDate'])),
        'shippingId': !exists(json, 'shippingId') ? undefined : json['shippingId'],
        'shippingProductsByShippingId': !exists(json, 'shippingProductsByShippingId') ? undefined : ((json['shippingProductsByShippingId'] as Array<any>).map(ShippingProductFromJSON)),
        'shippingStatus': !exists(json, 'shippingStatus') ? undefined : json['shippingStatus'],
        'trackingNumber': !exists(json, 'trackingNumber') ? undefined : json['trackingNumber'],
    };
}

export function ShippingToJSON(value?: Shipping | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderByOrderId': OrderToJSON(value.orderByOrderId),
        'orderId': value.orderId,
        'shippingDate': value.shippingDate === undefined ? undefined : (value.shippingDate.toISOString()),
        'shippingId': value.shippingId,
        'shippingProductsByShippingId': value.shippingProductsByShippingId === undefined ? undefined : ((value.shippingProductsByShippingId as Array<any>).map(ShippingProductToJSON)),
        'shippingStatus': value.shippingStatus,
        'trackingNumber': value.trackingNumber,
    };
}

